import type { Game } from '@hive/shared';
import { Settings2 } from 'lucide-react';
import { NavLink } from 'react-router';
import { cn } from '@/lib/utils';

/** The sidebar's list of games (Studio first) for Grid, plus a link to manage them. */
export function GameSwitcher({ games }: { games: readonly Game[] }) {
  const active = games.filter((g) => !g.archived_at);
  return (
    <div className="border-t border-line px-2.5 pt-3 pb-2">
      <p className="hud-label px-1.5 pb-1.5">Games</p>
      <nav aria-label="Games" className="flex flex-col">
        {active.map((g) => (
          <NavLink
            key={g.id}
            to={`/grid/${g.slug}`}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 px-2 py-1 text-sm text-muted hover:text-text',
                isActive && 'text-cyan shadow-[inset_2px_0_0_var(--color-cyan)]',
              )
            }
          >
            <span className="size-2 shrink-0" style={{ background: g.color ?? 'var(--color-line-hot)' }} aria-hidden />
            <span className="truncate">{g.name}</span>
          </NavLink>
        ))}
        <NavLink
          to="/games"
          className={({ isActive }) =>
            cn(
              'mt-1 flex items-center gap-2 px-2 py-1 font-mono text-[11px] text-dim hover:text-cyan',
              isActive && 'text-cyan',
            )
          }
        >
          <Settings2 className="size-3" aria-hidden />
          Manage games
        </NavLink>
      </nav>
    </div>
  );
}
